import { memo } from 'react'
import { Pressable, View } from 'react-native'
import styled, { css } from 'styled-components'
import { cursorPointer } from '../../../style/webStyles'
import { PosterLandscapeAd } from '../../ads/nativeAds/PosterLandscapeAd.js'
import { FilmLandscapePoster } from '../../content/FilmLandscapePoster/FilmLandscapePoster'

const calcHeight = (width, theme) => {
  const gutter = theme.spacing.sm
  return FilmLandscapePoster.calcHeight(width - gutter) + gutter
}

const containerStyle = css`
  padding-left: ${(props) => props.theme.spacing.sm / 2}px;
  padding-right: ${(props) => props.theme.spacing.sm / 2}px;
  padding-bottom: ${(props) => props.theme.spacing.sm}px;
`

const Container = styled(Pressable)`
  ${containerStyle};
`

const PressableContainer = styled(Pressable)`
  ${containerStyle};
  ${cursorPointer};
`

export const PosterLandscapeContent = memo(
  ({ item, theme, width, onChosen, premiumTitle, ...props }) =>
    item.type === 'ad' ? (
      <Container as={View}>
        <PosterLandscapeAd
          {...props}
          zone={item.zone}
          placementXs={item.placementMobile}
          placementSm={item.placement}
          index={item.index}
          listIndex={item.listIndex}
          width={width - theme.spacing.sm}
        />
      </Container>
    ) : (
      <View>
        <PressableContainer onPress={() => onChosen(item)}>
          <FilmLandscapePoster
            {...props}
            item={item}
            width={width - theme.spacing.sm}
            premiumTitle={premiumTitle}
          />
        </PressableContainer>
      </View>
    ),
)

PosterLandscapeContent.calcHeight = calcHeight
